import {
    selectCurrencies,
    selectPreferredCurrency
} from 'tradera/state/multi-currency/selectors';
import { setPreferredCurrencyThunk } from 'tradera/state/multi-currency/actions';
import Flag from 'tradera/components/flag/flag';
import { mapCurrencyCodeToCountryCode } from 'tradera/localization/map-currency-code-to-country-code';
import styles from './currency-select.module.scss';
import CheckIcon from '@tradera/blueprint/theme/icons2/check.svg?jsx';
import { Button } from 'tradera/components/atoms/button/button';
import { useAppDispatch, useAppSelector } from 'tradera/state/hooks';

type Currency = {
    code: string;
    shortName: string;
    longName: string;
};

type CurrencySelectProps = {
    onCurrencySelected?: () => void;
    inProfileMenu?: boolean;
    title?: string;
};

export const CurrencySelect = ({
    onCurrencySelected,
    inProfileMenu,
    title
}: CurrencySelectProps) => {
    const currencies: Currency[] = useAppSelector((state) =>
        selectCurrencies(state)
    );
    const preferredCurrency = useAppSelector((state) =>
        selectPreferredCurrency(state)
    );
    const dispatch = useAppDispatch();

    const handleOnClick = (code: string) => {
        dispatch(setPreferredCurrencyThunk(code));
        onCurrencySelected && onCurrencySelected();
    };

    return (
        <div className="pb-1">
            {title && (
                <div className="ml-2 py-1">
                    <strong>{title}</strong>
                </div>
            )}
            {currencies.map(({ code, shortName, longName }) => (
                <Button
                    fluid
                    theme="mainMenu"
                    className={`${styles.row} d-flex py-1 ${
                        inProfileMenu ? 'pl-4' : ''
                    } align-items-center`}
                    key={code}
                    onClick={() => {
                        handleOnClick(code);
                    }}>
                    <span className={inProfileMenu ? 'pl-3' : ''}>
                        <Flag
                            countryCodeIso2={mapCurrencyCodeToCountryCode(code)}
                            className="mr-1"
                        />
                        {preferredCurrency.code === code ? (
                            <strong>
                                {shortName} - {longName}
                            </strong>
                        ) : (
                            <span>
                                {shortName} - {longName}
                            </span>
                        )}
                    </span>
                    {preferredCurrency.code === code && (
                        <CheckIcon className="icon position-relative ml-auto" />
                    )}
                </Button>
            ))}
        </div>
    );
};
